import i18n from '@/i18n';
import { InscriptionCSS } from './Enum';

class CSQCOutilsCoursEte {
    racineLocalStorage = 'csqc_coursEte'

    debutErreurInscription = `<b><div><span>${i18n.t('dialogInscription.erreurAucunInscriptionEnCours')}</span ></div >`

    debutErreurInscriptionProchainesPeriodes = `${this.debutErreurInscription} <label>${i18n.t('dialogInscription.erreurProchainesPeriode')} </label>`

    EstExterne() {
      // Obtention de la valeur dans le localstorage
      const valeurEstExterneLocalstorage = localStorage.getItem(`${this.racineLocalStorage}_selectionInscription`);
      if (valeurEstExterneLocalstorage === '') {
        return false;
      }

      // Conversion de la valeur en nombre + validation
      const valeurEstExterne = parseInt(valeurEstExterneLocalstorage);
      return (valeurEstExterne === InscriptionCSS.AutreCSS || valeurEstExterne === InscriptionCSS.EtablissementPrive);
    }

    EstCSSMembre() {
      // Obtention de la valeur dans le localstorage
      const valeurEstCSSMembreLocalStorage = localStorage.getItem(`${this.racineLocalStorage}_selectionInscription`);
      if (valeurEstCSSMembreLocalStorage === '') {
        return false;
      }

      // Conversion de la valeur en nombre + validation
      const valeurEstCSSMembre = parseInt(valeurEstCSSMembreLocalStorage);
      return valeurEstCSSMembre === InscriptionCSS.CSSMonteregieEstrie;
    }

    EstCSSExterne() {
      // Obtention de la valeur dans le localstorage
      const valeurEstCSSExterneLocalStorage = localStorage.getItem(`${this.racineLocalStorage}_selectionInscription`);
      if (valeurEstCSSExterneLocalStorage === '') {
        return false;
      }

      // Conversion de la valeur en nombre + validation
      const valeurEstCSSExterne = parseInt(valeurEstCSSExterneLocalStorage);
      return valeurEstCSSExterne === InscriptionCSS.AutreCSS;
    }

    EstPrive() {
      // Obtention de la valeur dans le localstorage
      const valeurEstPriveLocalStorage = localStorage.getItem(`${this.racineLocalStorage}_selectionInscription`);
      if (valeurEstPriveLocalStorage === '') {
        return false;
      }

      // Conversion de la valeur en nombre + validation
      const valeurEstPrive = parseInt(valeurEstPriveLocalStorage);
      return valeurEstPrive === InscriptionCSS.EtablissementPrive;
    }

    ObtenirOrganisme() {
      if (this.EstCSSExterne()) return InscriptionCSS.AutreCSS;
      if (this.EstPrive()) return InscriptionCSS.EtablissementPrive;
      return InscriptionCSS.CSSMonteregieEstrie;
    }

    EstScolariseMaison() {
      const estScolariseMaison = localStorage.getItem(`${this.racineLocalStorage}_scolarisationMaison`);
      return estScolariseMaison === 'true';
    }

    ObtenirCssId() {
      return localStorage.getItem(`${this.racineLocalStorage}_CSSId`);
    }

    ObtenirURLPlateforme(optionCSS) {
      if (optionCSS != null) {
        if (optionCSS.urlPlateformeLocale != null && optionCSS.urlPlateformeLocale !== '-1') {
          return optionCSS.urlPlateformeLocale;
        } if (optionCSS.urlPlateformeLocaleExam != null && optionCSS.urlPlateformeLocaleExam !== '-1') {
          return optionCSS.urlPlateformeLocaleExam;
        }
        return '';
      }
      return null;
    }

    RetournerStringADateHeure(date, heure) {
      const dateSubstring = date.split('-');
      const heureSubstring = heure.split(':');

      return new Date(dateSubstring[0], parseInt(dateSubstring[1]) - 1, dateSubstring[2], heureSubstring[0], heureSubstring[1]);
    }

    // Va vérifier si la date actuelle est dans la période d'inscription.
    ContientCoursBlocSelonHeure(lstBlocOrganisme) {
      let contientUnCoursAuMinimum = false;
      const dateActuelle = new Date();

      lstBlocOrganisme.forEach((blocOrganisme) => {
        // La date est supposé toujours être rempli. (Selon ce que j'ai discuté avec David)
        const dateBlocDebut = this.RetournerStringADateHeure(blocOrganisme.bloc.dateDebutInscription, blocOrganisme.bloc.heureDebutInscription);
        const dateBlocFin = this.RetournerStringADateHeure(blocOrganisme.bloc.dateFinInscription, blocOrganisme.bloc.heureFinInscription);

        if (dateActuelle > dateBlocDebut && dateActuelle < dateBlocFin) {
          contientUnCoursAuMinimum = true;
        }
      });
      return contientUnCoursAuMinimum;
    }

    CreerMessageErreurInscription(listeBlocOrganisme) {
      let dateDisponible = '';
      const blocsAffiches = [];

      const selectionInscription = parseInt(localStorage.getItem(`${this.racineLocalStorage}_selectionInscription`));

      listeBlocOrganisme = this.ObtenirEtTrierBlocsFutursOuverture(listeBlocOrganisme);

      listeBlocOrganisme.forEach((blocOrganisme) => {
        if (!blocsAffiches.includes(blocOrganisme.bloc.id)) {
          const blocDateDebut = this.RetournerStringADateHeure(blocOrganisme.bloc.dateDebutInscription, blocOrganisme.bloc.heureDebutInscription);
          const blocDateFin = this.RetournerStringADateHeure(blocOrganisme.bloc.dateFinInscription, blocOrganisme.bloc.heureFinInscription);

          // Information des blocs (Ex: Nom bloc - Du 10 juin 10:00 au 21 juin 2024 16:00)
          dateDisponible += '<li>';
          dateDisponible += `${blocOrganisme.bloc.identifiant} - `; // Nom bloc
          // Si contient une periode ouvert a tous
          if (blocOrganisme.bloc.dateOuvertATous != null && blocOrganisme.bloc.heureOuvertATous != null && selectionInscription !== InscriptionCSS.CSSMonteregieEstrie) {
            const blocDateOuvertATous = this.RetournerStringADateHeure(blocOrganisme.bloc.dateOuvertATous, blocOrganisme.bloc.heureOuvertATous);
            dateDisponible += `Du ${blocDateOuvertATous.toLocaleString('fr', { day: 'numeric', month: 'long' })} ${blocOrganisme.bloc.heureOuvertATous} au `; // Date ouvert a tous + heure ouvert a tous
          } else {
            dateDisponible += `Du ${blocDateDebut.toLocaleString('fr', { day: 'numeric', month: 'long' })} ${blocOrganisme.bloc.heureDebutInscription} au `; // Date début inscription + heure début inscription
          }
          dateDisponible += `${blocDateFin.toLocaleString('fr', { day: 'numeric', month: 'long', year: 'numeric' })} `; // Date fin inscription
          dateDisponible += `${blocOrganisme.bloc.heureFinInscription}`; // Heure fin inscription
          dateDisponible += '</li>';

          blocsAffiches.push(blocOrganisme.bloc.id);
        }
      });

      return blocsAffiches.length > 0 ?
        `${this.debutErreurInscriptionProchainesPeriodes} <ul style='float:right'>${dateDisponible}</ul></b>` :
        this.debutErreurInscription;
    }

    ObtenirEtTrierBlocsFutursOuverture(lstBlocOrganisme) {
      let selectionInscription = localStorage.getItem(`${this.racineLocalStorage}_selectionInscription`);
      // S'il est null, ont set MonteregieEstrie par défaut
      if (selectionInscription === null) {
        selectionInscription = InscriptionCSS.CSSMonteregieEstrie;
        localStorage.setItem(`${this.racineLocalStorage}_selectionInscription`, selectionInscription);
      }
      selectionInscription = parseInt(selectionInscription);

      // Filtrer pour les blocs futurs seulement
      if (selectionInscription === InscriptionCSS.CSSMonteregieEstrie) {
        lstBlocOrganisme = lstBlocOrganisme.filter((bo) => new Date(this.RetournerStringADateHeure(bo.bloc.dateDebutInscription, bo.bloc.heureDebutInscription)) > Date.now());
      } else {
        lstBlocOrganisme = lstBlocOrganisme.filter((bo) => new Date(this.RetournerStringADateHeure(bo.bloc.dateDebutInscription, bo.bloc.heureDebutInscription)) > Date.now() ||
          new Date(this.RetournerStringADateHeure(bo.bloc.dateOuvertATous, bo.bloc.heureOuvertATous)) > Date.now());
      }

      // Filtrer pour les blocs qui ont comme organismeId égal à selectionInscription ou qui ont une période ouverte à tous
      lstBlocOrganisme = lstBlocOrganisme.filter((bo) => bo.organismeId === selectionInscription);

      // Mettre les blocs en ordre de date d'inscription
      lstBlocOrganisme = lstBlocOrganisme.sort(
        // eslint-disable-next-line max-len
        (a, b) => new Date(this.RetournerStringADateHeure(a.bloc.dateDebutInscription, a.bloc.heureDebutInscription)) - new Date(this.RetournerStringADateHeure(b.bloc.dateDebutInscription, b.bloc.heureDebutInscription)),
      );

      return lstBlocOrganisme;
    }
}

const csqcOutilsCoursEte = new CSQCOutilsCoursEte();

export default csqcOutilsCoursEte;
